<div style="height:80%; overflow: hidden; ">
    <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
      <div class="form-group row">
        <!-- <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-6">
                <input type="text"  name="pincode" maxlength="4"  id="pin" pattern="\d{4}" required/>

                <input
                    type="text"
                    name="txtOdGodine"                                 
                    formControlName="OdGodine"
                    pattern="^[0-9]{4}$"
                >
                <div class="form-error" *ngIf="submitted && fc.OdGodine.invalid">
                    <span *ngFor="let validation of errorMessages.OdGodine">
                        <span class="error-message" *ngIf="fc.OdGodine.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                        </span>
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <yt-number-input-v3
                    name="txtOdGodine"                                 
                    [Label]="'PREGLEDGO.ODGODINE.SINGULAR'" 
                    formControlName="OdGodine"
                    [FormatString]="'1.0-0'"
                >
                </yt-number-input-v3>
                <div class="form-error" *ngIf="submitted && fc.OdGodine.invalid">
                    <span *ngFor="let validation of errorMessages.OdGodine">
                        <span class="error-message" *ngIf="fc.OdGodine.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                        </span>
                    </span>
                </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-3">
          <yt-fw-date-picker-popup
              name="txtDatumOd"
              formControlName="DatumOd"
              [ngClass]="{'is-invalid' : submitted && fc.DatumOd.invalid}"
              [Label]="'PREGLEDGO.DATUMOD.SINGULAR'">
          </yt-fw-date-picker-popup>
          <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
              <span *ngFor="let validation of errorMessages.DatumOd">
                  <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group row">
            <button type="button" class="btn btn-primary" id="btnLoadData" (click)="LoadData()" [disabled]="podaciSuUcitani">
              Učitaj podatke
            </button>
            <button type="button" class="btn btn-primary" id="btnMenjajUslove" (click)="MenjajUslove()" [disabled]="!podaciSuUcitani">
              Menjaj uslove
            </button>
            <button type="button" class="btn btn-primary" id="btnLoadPDF" (click)="LoadPDF()">
              <span class="fa fa-fw fa-print"></span>
              Štampaj
            </button>
          </div>
        </div>
      </div>
  
 
    </form>
    <yt-fw-default-table *ngIf="modelData!=null && modelData.MainList!=null"
     [Config]="Config"
     [Items]="items"
     [TableColumns]="modelData.MainList.TableColumns"
     [Condensed]="CondensedTable"
     [ShowLoader]="MainItemsLoading"
     (RefreshDataClicked)="RefreshData()"
    ></yt-fw-default-table>
</div>
